import { useLocalStorage } from "@mantine/hooks";
import { useMemo } from "react";

import { SavedPronosticV2 } from "pronosticsv2/types/saved.pronosticv2.model";

export function useSavedPronosticV2(pronosticV2Id: string) {
  const [savedPronosticV2s, setSavedPronosticV2s] = useLocalStorage<
    Record<string, SavedPronosticV2>
  >({
    key: "pronosticv2",
    getInitialValueInEffect: false,
  });

  return useMemo(
    () =>
      [
        (savedPronosticV2s || {})[pronosticV2Id],
        (savedPronosticV2: SavedPronosticV2) =>
          setSavedPronosticV2s((pronosticV2s) => {
            return {
              ...pronosticV2s,
              [pronosticV2Id]: savedPronosticV2,
            };
          }),
      ] as const,
    [savedPronosticV2s, setSavedPronosticV2s, pronosticV2Id],
  );
}
